import { NgModule } from '@angular/core';

import { RenderStorageProductsService } from './render-storage-products/render-storage-products.service';
import { RenderStorageService } from './render-storage.service';


@NgModule({
  imports: [],
  declarations: [],
  providers: [
    RenderStorageService,
    RenderStorageProductsService
  ]
})
export class RenderStorageModule { }
